var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-modal',_vm._g(_vm._b({attrs:{"value":_vm.value,"confirm-text":"Save Event","title":"Edit Event","hide-louis":"","persistent":""}},'generic-modal',_vm.$props,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }